import {SupportedLocales} from '#types/locale.js';

export const userInvitationsLang = {
  [SupportedLocales.EN]: {
    brandName: 'GrowthLoop',
    headline: 'Compound Marketing Engine',
    caption: 'The Easiest Way to Drive Compounding Growth',
    pendingTitle: 'Join your team on GrowthLoop',
    pendingBody: (inviterName: string, inviterEmail: string) =>
      `${inviterName} (${inviterEmail}) has invited you to collaborate in ${inviterName}'s Organization on GrowthLoop.`,
    pendingInstruction:
      'Click on the button below and then choose sign up to accept the invitation',
    acceptInvitation: 'Accept invitation',
  },
  [SupportedLocales.ES]: {
    brandName: 'GrowthLoop',
    headline: 'Motor de marketing compuesto',
    caption: 'La forma mas facil de impulsar el crecimiento compuesto',
    pendingTitle: 'Unete a tu equipo en GrowthLoop',
    pendingBody: (inviterName: string, inviterEmail: string) =>
      `${inviterName} (${inviterEmail}) te invito a colaborar en la organizacion de ${inviterName} en GrowthLoop.`,
    pendingInstruction:
      'Haz clic en el boton de abajo y luego elige registrarte para aceptar la invitacion',
    acceptInvitation: 'Aceptar invitacion',
  },
};
